module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.gift.red-9707d847dd25fdd2d22e1b125531f6f9.svg";